/**
 * The Player object
 */

require('script-loader!../public/js/lib/jquery.countdown/jquery.countdown.js')
require('script-loader!../public/js/lib/flowtype.js')
require('script-loader!../public/js/lib/jquery.filter.js')
require('script-loader!../public/js/lib/jquery.lazySizes.min.js')
require('script-loader!../public/js/lib/owl.carousel.min.js')
require('../public/css/flowplayer.commercial-7.2.7/skin/skin.css')
require('../public/css/player/player.css')
require('./components/Chat.jsx')

import { debugDump } from './util/debug.js';

const base = window.flowplayer
const flowplayer = require('./flowplayer')
const slideout = require('slideout')
const _ = require('lodash')
const util = require('./util')
const api = require('./api')
const EventEmitter = require('fbemitter').EventEmitter
const momentTimezone = require('moment-timezone')
const moment = require('moment')
const enquire = require('enquire.js')
const mobile_detect = require('mobile-detect')
const md = new mobile_detect(window.navigator.userAgent)
const debug = require('debug')('streamspot:player')
const cloudfrontAssets = 'https://d2i0qcc2ysg3s9.cloudfront.net/';

const Player = {
  flowplayerId: '#player',
  chromecast: false,
  playlist: [],
  internal: {
    api: api
  },
  debug: window.debug,
  byBroadcastor: false,
  baseOverlay: null,
  switchingHlsLevels: false,
  playOverlay: null,
  audioOnly: false,
  backgroundOverlay: null,
  config: {},
  util: util,
  lock: {},
  emitter: new EventEmitter(),
  disableMenu: false,
  videos: null,
  usedCategories: [],
  mobile: md.mobile(),
  phone: md.phone(),
  tablet: md.tablet(),
  userAgent: md.userAgent(),
  os: md.os(),
  categories: null,
  broadcasts: null,
  state: null,
  isSafari: null,
  isChrome: null,
  overlay: {
    now: 'home'
  },
  currentVideo: {},
  currentResolution: {
    resolution: 'auto'
  },
  menu: null,
  church: null,
  branding: null,
  currentEvent: 'undefined',
  currentLive: null, //added with new ingest platform
  enableDVR: 0, //added with new ingest platform, determined by currentLiveVariable
  liveManifest: null, //added for new ingest platform
  liveBroadcastTitle: 'Live Broadcast',
  //liveCaptionFile: null,
  googleTrackingId: null,
  qs: {
    animateBg: 0,
    archiveCarousel: 0,
    autoPlay: 0,
    bgImage: 'streamspotsplash.jpg',
    bgLink: 'https://d2i0qcc2ysg3s9.cloudfront.net/streamspot-player-bg-grey-1.jpg',
    menueLogo: 'https://cdn2.streamspot.com/streamspot-logo-centered-150x44.png',
    branding: 1,
    countdown: 1,
    liveOnly: 0,
    playerDescription: '',
    showBg: 1,
    disableLockBack: false,
    showMenuCountdown: 1,
    showDesc: 1,
    showDonate: 1,
    showRecentArchives: 1,
    showArchives: 1,
    showRoku: 1,
    showSchedule: 1,
    showSubscribe: 0,
    showThumb: 0,
    showTitle: 1,
    showVenueInfo: 0,
    textColor: 'white',
    thumbImage: null,
    thumbLink: '//cdn2.streamspot.com/streamspot-od-w-circles-160x90',
    dvr: 1 //set globally in venue_meta settings, trumps enableDVR setting
  },
  /**
   * This is the entry point of player.s
   * @param  {string} el                        Element to init player on
   * @param  {object} config                    configuration object, this will
   * be merged with the default configuration above - 'this.qs'
   * @param  {function} playerDoneLoadingCallback Callback to be executed
   * when the player is done loading
   */

  start: function(el, config, playerDoneLoadingCallback) {
    if( window.setupCompleted ){
      debug('DUPLICATE, some API calls will be excluded')
    }
    var self = this
    if( el != this.flowplayerId ){
      this.flowplayerId = '#ss-player'
    }
    //debug('PLAYER STARTED for %s',this.flowplayerId)
    if (!playerDoneLoadingCallback) {
      //debug('playerDoneLoadingCallback is NOT DONE :(')
      playerDoneLoadingCallback = function() {}
    }
      //grab window params to determine player type
    _.extend(this.qs, this.util.qs(window))
   //debug('BD Player type defined as: ' + JSON.stringify(this.util.qs(window)))
    if (window.Player.os === 'iOS' && !window.Player.tablet) {
      $(this.flowplayerId).addClass('is-iOS')
    }

    if (window.Player.os === 'AndroidOS' && !window.Player.tablet) {
      $(this.flowplayerId).addClass('is-AndroidOS')
    }

    //extend passed in config with base
    _.extend(this, config)

    //If the ssId is passed in, get church now
    if (this.qs.cn && !this.broadcaster) {
      this.getBroadcaster(this.qs.cn, this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }

    this.qs.playerId = (this.qs.playerId || this.qs.p) // support p param

      // If this is a single video, get video
    if (this.qs.video && !this.video) {
     debug('BD qs video set as ' + this.qs.video)
      this.qs = {
        video: this.qs.video,
        showDonate: 0,
        showRoku: 1,
        cn: this.qs.cn,
        idHash: this.qs.idHash,
        showSubscribe: 0
      }
      this.getVideo(this.qs.video, this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }
    // Get player meta
    if (this.qs.playerId && !this.qs.version) {
     //debug('BD getting metadata for playerId: ' +  this.qs.playerId)
      this.getMeta(this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }

    // TODO: append with consolidated live endpoint?
    // Get Church Info
    if (!this.broadcaster) {
      var ssId = (this.qs.cn || this.qs.ssId || this.qs.idHash)
      this.getBroadcaster(ssId, this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }
    //see if it's safari an update autoplay as required
    if( this.isSafari === null ){
      //debug('UA: ' +  navigator.userAgent);
      if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        this.isSafari = true;
      } else {
        this.isSafari = false;
      }
      //debug("isSafari: " + this.isSafari);
      if( this.isSafari ){
        //debug('Safari detected, disabling autoPlay manually');
        this.qs.autoPlay = 0;
      }
    }
    //added for android autoplay issues
    if (window.Player.os === 'AndroidOS') {
      //$(this.flowplayerId).addClass('is-AndroidOS')
      debug('BD: AndroidOS detected, diabling autoplay')
      this.qs.autoPlay = 0;
    }

    //added for chrome autoplay issues
    if( this.isChrome === null ){
      if ( (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) &&
      (navigator.vendor.toLowerCase().indexOf("google") > -1) ){
        this.isChrome = true;
      } else {
        this.isChrome = false;
      }
      //debug("isSafari: " + this.isSafari);
      if( this.isChrome ){
        //debug('Chrome detected, disabling autoPlay manually');
        this.qs.autoPlay = 0;
      }
    }


    // TODO: replace with consolidated, live endpoint
    // if broadcasting, get lock information
    if (this.broadcaster.isBroadcasting && _.isEmpty(this.lock)) {
      this.checkIsLocked(this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }

    /* replacing with consolidated live endpoint
    // if broadcasting, check for current event
    if (this.broadcaster.isBroadcasting &&  this.currentEvent === 'undefined' ) {
      debug('current event not set, calling api')
      this.checkCurrentEvent(this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    } */
    if (this.broadcaster.isBroadcasting && !this.currentLive ){
      this.checkCurrentLive(this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }

    //calls the v2/live endpoint, important vars are: this.currentLive.liveManifest, this.currentLive.event, this.currentLive.liveObject
    if( this.currentLive ){
      if( this.currentLive.success ){
        this.currentLive = this.currentLive.data
        console.log('currentLive: ' + JSON.stringify(this.currentLive) )
        this.currentEvent = this.currentLive.event
        if( this.currentLive.liveManifest ){
          this.liveManifest = this.currentLive.liveManifest
        }
      }
    } else {
      if ( this.broadcaster.live_src.cdn_hls ){
        this.liveManifest = this.broadcaster.live_src.cdn_hls
      }
    }

    if( this.currentEvent != 'undefined' ){
      if( this.currentEvent === null ){
        debug('current event is undefined')
      } else {
        debug('current event defined as: ' + JSON.stringify(this.currentEvent))
        this.liveBroadcastTitle = this.currentEvent.title; //override the standard live title
        /*
        if( this.currentEvent.captionFile != null ){
          debug('live caption file defined as %s', this.currentEvent.captionFile)
          this.liveCaptionFile = this.currentEvent.captionFile; //override the standard caption
        }
        */
      }
    }
    //used to pull last player created for venue page branding and options
    if (this.byBroadcastor && !this.qs.version && !this.qs.video) {
      this.getMetaByBroadcastor(null, this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }

    //check for DVR
    //now set the DVR
    if( this.currentLive && this.qs.dvr ){
      if( this.currentLive.liveObject.enableDVR ){
        debug('DVR enabled')
        this.enableDVR = false;
        if (typeof(this.broadcaster.gen3)!=='undefined' && this.broadcaster.gen3!=="0")
        {
          this.enableDVR = this.currentLive.liveObject.enableDVR
        }
      }
    }

    //check for custom branding from whiteLabel
    if( this.broadcaster && this.broadcaster.brandingId != null && this.branding === null ){
      this.checkCustomBranding(this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }
    if( this.branding != null ){
      debug('branding defined as: ' + JSON.stringify(this.branding))
      if (typeof this.qs.bgLink !== 'undefined') {
        //-1 means it matches
        if( this.qs.bgLink.indexOf("streamspot") !== -1 && this.qs.bgLink.indexOf("eCatholic") !== -1){
          //only change default bg if it's a streamspot bg
          debug('default StreamSpot bg changed to: ' + this.branding.brandPlayerBg);
          this.qs.bgLink = this.branding.brandPlayerBg
        }
      }
    }

    /** appears to be redundant from line 197
    if (this.byBroadcastor && !this.qs.version && !this.qs.video) {
      this.getMetaByBroadcastor(null, this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }
    **/

    // Called if category player is set
    if (this.qs.category && !this.videos) {
      this.getVideos(this.start.bind(this, el, config, playerDoneLoadingCallback))
      return
    }

    this.basePlayerConfig = this.generateBasePlayerConfig()
    //debug('BD basePlayerConfig set to: ' + JSON.stringify(this.basePlayerConfig))
    //this is a consolidation of basePlayerConfig and el
    this.api = base(el, this.basePlayerConfig)
    //debug('BD this.api variable set to: ' + JSON.stringify(this.api))

    /** BEGIN LOADING PLAYER BY POPULATING TEMPLATES **/

    var playerEL = $(el)
    var template = require('./templates/player.ejs')
    var html = template()
    playerEL.append(html)
    playerEL.addClass('fp-slim fp-outlined fp-mute flowplayer play-button')
    this.baseOverlay = $('#player-overlay')
    this.playOverlay = $('#play-overlay')
    this.backgroundOverlay = $('#background-overlay')

    this.disableFullscreenIfDisabled()
    if (this.qs.liveOnly) {
      this.qs.showRecentArchives = 0
      this.qs.showArchives = 0
      this.disableMenu = this.disableMenu ? 1 : this.qs.disableMenu
      this.loadLiveOnlyPlayer()
    } else if (this.qs.cn || this.qs.idHash) {
      this.qs.disableMenu = false
      this.loadDefaultPlayer()
    } else if (this.qs.playerId) {
      this.qs.disableMenu = false
      this.loadPlayer()
    } else if (this.qs['video']) {
      this.loadVideoPlayer()
    }

    if(this.mobile){
      this.disableLockBack = true
      var locked = this.lock.isPrivate && window.localStorage.getItem('locked' + this.lock.eventId) !== 'true'
      if(locked){
        this.lockEvent(this.lock, null, function() {
          self.state = 'liveAndNotBroadcasting'
        })
      }
    }

    //loads context (right-click) menu overflowplayer
    //bypassing to help troubleshoot
    this.appendContextMenu()
    flowplayer.registerEventHandlers(Player)
    //this.initChromecast()

    /** should no longer require
    window.setInterval(function() {
      self.toggleLiveButton()
    }, 45000)
    **/

    //moneysmiths bullshit debugger
    //debug('BD FINISHED playerDoneLoadingCallback function called')
    window.setupCompleted = true
    //debugDump(self, null)
    playerDoneLoadingCallback()
  },
  disableFullscreenIfDisabled: function() {
    //debug('Player:disableFullscreenIfDisabled')
    var fullscreenDisabled = (window.document.fullscreenEnabled ||
      window.document.webkitFullscreenEnabled ||
      window.document.mozFullScreenEnabled ||
      window.document.msFullscreenEnabled)
    var self = this
    //debug('Player:disableFullscreenIfDisabled: Fullscreen Disabled: %s', fullscreenDisabled)
    /**
    if (!fullscreenDisabled) {
      $('.fp-fullscreen').click(function(){
        debug('Player:disableFullscreenIfDisabled: Fullscreen button clicked')
        //self.toggleFullScreenOverlay('show')
      }.bind(window))
    } **/
  },
  triggerMediaQueries: function() {
    //debug('Player:triggerMediaQueries')
    if(util.supportMediaQuery()){
      debug('Player:triggerMediaQueries: This device supports media queries')
      enquire.register('all and (max-width: 480px)', {
        match: function() {
          debug('Player:triggerMediaQueries: Matched a mobile device')
          $(this.flowplayerId).addClass('no-time no-brand no-volume')
        },
        unmatch: function() {
          debug('Player:triggerMediaQueries: Unmatched a mobile device')
          $(this.flowplayerId).removeClass('no-time no-brand no-volume')
        }
      })
    }
  },
  checkCustomBranding: function(cb) {
   //debug('BD checkCustomBranding API called')
    var self = this
    api.getBranding(this.broadcaster.brandingId, function(branding) {
      self.branding = branding
      cb()
    })
  },
  checkCurrentEvent: function(cb) {
   debug('BD checkCurrentEvent API called for ' + this.broadcaster.ssId)
    var self = this
    api.getCurrentEvent(this.broadcaster.ssId, function(currentEvent) {
      self.currentEvent = currentEvent
      cb()
    })
  },
  checkCurrentLive: function(cb) {
   debug('BD checkCurrentLive API called for ' + this.broadcaster.ssId)
    var self = this
    api.getCurrentLive(this.broadcaster.ssId, function(currentLive) {
      self.currentLive = currentLive
      cb()
    })
  },
  loadVideoPlayer: function() {
   //debug('BD loadVideoPlayer function called')
    var self = this
    this.state = 'single'
    this.qs.showArchives = 0
    this.qs.showRecentArchives = 0
    this.qs.showSchedule = 0
    var thumbnail = this.video.thumbnailLink
    if ($(this.flowplayerId).width() >= 400) {
      thumbnail = this.video.thumbnailLinkHiRes
    }
    if (_.isEmpty(this.video.thumbnailLink)){
      thumbnail = 'https://d2i0qcc2ysg3s9.cloudfront.net/streamspot-player-bg-grey-1.jpg'
    }
    this.toggleSingleVideoOverlay('show')
    this.toggleMenuWatching('show')
    $(this.flowplayerId).css('background-image', 'url(' + thumbnail + ')')
    if (parseInt(this.video.private)) {
      this.lockVod(this.video, function() {
        $('.single-video-overlay').off('click.play-action').on('click.play-action', function() {
          self.play(self.video)
        })
      })
    }
  },
  toggleLiveWatermark: function(display) {
   //debug('BD toggleLiveWatermark function called with action: ' + display)
    if (display === 'hide') {
      $('.fp-ui .player-live-watermark').hide()
    } else {
      if (this.qs.liveWatermark) {
        // Append if not there
        if (_.isEmpty($('.fp-ui .player-live-watermark'))) {
          $('.fp-ui').append('<span class="player-live-watermark" ><i class="fa fa-circle red"></i> Live</span>')
        }
        //show, only if broadcasting
        if (this.state == 'liveAndBroadcasting') $('.fp-ui .player-live-watermark').show()
      } else {
        $('.fp-ui .player-live-watermark').hide()
      }
    }
  },
  toggleLiveButton: function() {
   //debug('BD toggleLiveButton function called')
    var self = this
    if (self.state == 'liveAndBroadcasting') {
      debug('BD toggleLiveButton is liveAndBroadcasting, removing button')
      $('.live-badge').hide()
      $('.toolIconLive').addClass('toolIconHidden')
      return
    }
    if( $(".flowplayer.is-ready").length ){
      api.checkisBroadcasting(self.broadcaster.ssId, function(isBroadcasting) {
        if (isBroadcasting && self.state !== 'liveAndBroadcasting' && self.state !== 'locked') {
          //debug('BD toggleLiveButton live, adding, state: %s', self.state)
          $('.live-badge').show()
          $('.toolIconLive').removeClass('toolIconHidden')
          $('.watch-live-broadcast').off('click').on('click', function() {
            self.loadLiveBroadcast()
          })
        } else {
          //debug('BD toggleLiveButton not-live, remvoing, state: %s', self.state)
          //$('.fp-live-broadcasting').hide()
          $('.live-badge').hide()
          $('.toolIconLive').addClass('toolIconHidden')
        }
        //hide if category player
        if( self.qs.category ){
          $('.live-badge').hide()
        }
      })
    }
  },
  toggleSingleVideoOverlay: function(display) {
   //debug('BD toggleSingleVideoOverlay function called with action: ' + display)
    var self = this
    if (display === 'hide') {
      $('#player-overlay').off('click.play-action')
      this.hideOverlay()
    } else if (display == 'show') {
      this.overlayUpdate('home')
      $('#player-overlay').removeClass().addClass('single-video-overlay')
      var template = require('./templates/single-video-overlay.ejs')
      var html = template()
      $('.single-video-overlay').html(html)
      $('#player-overlay').show()
      $('#play-overlay').show()
      $('.single-video-overlay').off('click').on('click', function() {
        self.play(self.video)
      })
      this.toggleBackgroundOverlay('show')
      this.helperFunctions($('#player-overlay')) // Make sure these don't run every time.
      this.registerActions()
    }
  },
  getVideos: function(cb) {
    var self = this
    var ssId = this.broadcaster.ssId
    if (this.videos) return cb()
    if(this.qs.category){
      debug('BD: env set to: ' + process.env.NODE_ENV) // dev
     //debug('BD getVideosByCategory API called')
      api.getVideosByCategory(ssId, this.qs.category, function(data) {
        self.videos = data.videos
        self.category = data.category
        if (_.isEmpty(self.videos)) {
          self.toggleMenuArchives('hide')
          self.toggleMenuRecentArchives('hide')
        }
        cb()
      })
    } else {
       debug('BD getVideos API called')
      api.getVideos(ssId, function(data) {
        self.videos = data.videos
        self.videoCategories = data.categories
        if (_.isEmpty(self.videos)) {
          self.toggleMenuArchives('hide')
          self.toggleMenuRecentArchives('hide')
        }
        cb()
      })
    }
  },
  getMeta: function(cb) {
   //debug('BD getMeta API called')
    var self = this
    if (this.qs.version) return cb()
    api.getMeta(this.qs.playerId, function(meta) {
      _.extend(self.qs, meta)
      cb()
    })
  },
  getMetaByBroadcastor: function(ssId, cb) {
   //debug('BD getMetaByBroadcaster API called')
    var self = this
    if (this.qs.version) return cb(this.qs)
    api.getMetaByBroadcastor((ssId || this.broadcaster.ssId), function(meta) {
      self.qs.version = 'api'
      if (meta) _.extend(self.qs, meta)
      //check for upcoming broadcasts schedule if venue page and not already defined
      if( !self.broadcasts && self.qs.showSchedule ){
        //debug('pulling upcoming broadcasts for venue page')
        self.venuePageUpcomingBroadcasts()
      }
      cb()
    })
  },
  checkIsLocked: function(cb) {
   //debug('BD checkIsLocked API called')
    var self = this
    if (!_.isEmpty(this.lock)) return cb()
    api.checkIsLocked(this.broadcaster.ssId, function(lock) {
      self.lock = lock
      cb()
    })
  },
  getVideo: function(id, cb) {
   //debug('BD getVideo API called')
    var self = this
    if (this.videos) return cb()
    api.getVideo(id, function(data) {
      self.qs.ssId = data.church
      self.video = data
      cb()
    })
  },
  getBroadcaster: function(id, cb) {
    var self = this
    if (this.broadcaster) return cb()
   //debug('BD getBroadcaster API called')
    api.getBroadcaster(id, function(data) {
      self.broadcaster = data
      self.broadcaster = data
      cb()
    })
  },
  updateBroadcaster: function(id, cb) {
    var self = this
    if (this.updatedBroadcaster){
     //debug('BD updatedBroadcaster has already run, not calling API again')
      return cb(this.broadcaster)
    } else {
      this.updatedBroadcaster = true
     //debug('BD updateBroadcaster API called for ssId %s', id)
      api.getBroadcaster(id, function(data) {
        self.broadcaster = data
        cb(data)
      })
    }
  },
  getCategories: function(cb) {
    var self = this
    if( this.videoCategories ){
      debug('categories already set by videos endpoint')
      self.categories = this.videoCategories //re-use from getVideosByBroadcaster endpoint
      this.categories = this.videoCategories
      return cb()
    }
    if (this.categories) return cb()
    var ssId = this.broadcaster.ssId
    api.getCategories(ssId, function(data) {
      self.categories = data
      cb()
    })
  },
  getUpcomingBroadcasts: function(cb) {
    var self = this
    if (this.broadcasts) return cb()
   //debug('BD getUpcomingBroadcasts function called')
    var ssId = this.broadcaster.ssId
    api.getUpcomingBroadcasts(ssId, function(broadcasts) {
      self.broadcasts = broadcasts.broadcasts
      self.next_broadcast = broadcasts.next
      cb()
    })
  },
  appendMenuLiveCountdown: function() {
    if (!this.broadcasts) {
      this.getUpcomingBroadcasts(this.broadcaster.ssId, this.appendMenuLiveCountdown.bind(this))
      return
    }
    if (this.next_broadcast && this.qs.showMenuCountdown && !this.broadcaster.isBroadcasting) {
      var timeOfBroadcast = momentTimezone.tz(this.next_broadcast.start, this.next_broadcast.timezone)
      var utcOffset = new Date().getTimezoneOffset()
      var userTime = timeOfBroadcast.utcOffset(utcOffset).toDate()
      var template = require('./templates/menu-countdown.ejs')
      var html = template()
      $('.menu-countdown-section').html(html)
      $('.menu-countdown-section').find('.player-live-countdown').countdown(userTime, function(event) {
        $(this).html(event.strftime('%D days %H:%M:%S'))
      })
    }
  },
  toggleMenuCountdown: function(display) {
    if (display === 'hide') {
      $('.menu-countdown-section').hide()
    } else if (display == 'show') {
      if (this.qs.showMenuCountdown) {
        $('.menu-countdown-section').show()
      }
    }
  },
  loadPlayer: function() {
   //debug('BD loadPlayer (playerId) function called')
    if (this.qs['autoPlay'] && this.broadcaster.isBroadcasting && !this.mobile) {
      this.state = 'liveAndNotBroadcasting'
      //this.loadLiveBroadcast()
      this.loadLiveStatic()
    } else {
      this.state = 'vod'
      this.toggleHomeOverlay('show')
      //this.appendLiveButton()
    }
  },
  lockEvent: function(event, config, cb) {
   //debug('BD lockEvent function called')
    if (!_.isEmpty(config)) _.extend(this, config)
    var self = this
    if (window.localStorage.getItem('locked' + event.eventId)) return cb()
    this.state = 'locked'
    this.overlayUpdate('lock')
    $('.player-lock').fadeIn(300)
    var template = require('./templates/lock-overlay.ejs')
    var html = template()
    $('.player-lock').html(html)
    this.helperFunctions($('.player-lock'))
    if(this.disableLockBack) {
      $('.action-lock-back-to-home').hide()
      //debug('action-lock-back-to-home disabled')
    }
    $('#player-lock-form').submit(function(e) {
      e.stopPropagation()
      e.preventDefault()
      var password = $('.player-lock-password').val()
     //debug('BD password submitted to unlock player: ' + password)
      if(_.isEmpty(password)){
        $('.player-lock-password').addClass('animated shake red-background')
        $('.player-lock-password').change(function() {
          $('.player-lock-password').off()
          $('.player-lock-password').removeClass('animated shake red-background')
        })
        $('.player-lock-text').text('Please a password to view.')
      }
      api.eventAuth(event.eventId, password, function(lock) {
        if (lock) {
          $('.player-lock').hide()
            // Save data to the current local store
          window.localStorage.setItem('locked' + event.eventId, true)
          if (self.mobile) {
            self.api.disable(false)
          }
          cb()
        } else {
          $('.player-lock-password').addClass('animated shake red-background')
          $('.player-lock-password').change(function() {
            $('.player-lock-password').off()
            $('.player-lock-password').removeClass('animated shake red-background')
          })
          $('.player-lock-text').text('Please enter correct password to view.')
          $('.player-lock-password').val('')
        }
      })
      return false
    })
    this.registerActions()
    $('.player-lock-header').html('This broadcast is private, please enter the password provided by <span class="church-name">' + this.broadcaster.name + '</span> to view:')
  },
  lockVod: function(video, cb) {
   //debug('BD lockVod function called')
    if (window.localStorage.getItem('locked' + video.idHash)) return cb()
    this.state = 'locked'
    this.overlayUpdate('lock')
    $('.player-lock').fadeIn(300)
    var template = require('./templates/lock-overlay.ejs')
    var html = template()
    $('.player-lock').html(html)
    this.helperFunctions($('.player-lock'))
    this.registerActions()
    if( !this.mobile ){
      $('.player-lock-header').html('This content is private, please enter the password provided by <span class="church-name">' + this.broadcaster.name + '</span> to view:')
    } else {
      //simplify the view
      $('.player-lock-header').html('Please enter the password to view this content:')
    }
    $('#player-lock-form').submit(function(event) {
      event.preventDefault()
      Player.lockVodFormAction(video, cb)
      return false
    })
  },
  lockVodFormAction: function(video, cb) {
    var password = $('.player-lock-password').val()
    api.videoAuth(video.idHash, password, function(lock) {
      if (lock) {
        $('.player-lock').hide()
        window.localStorage.setItem('locked' + video.idHash, true)
        return cb()
      } else {
        $('.player-lock-password').addClass('animated shake red-background')
        $('.player-lock-password').on('input', function() {
          $('.player-lock-password').off()
          $('.player-lock-password').removeClass('animated shake red-background')
        })
        $('.player-lock-text').text('Please enter correct password to view archive.')
        $('.player-lock-password').val('')
      }
    })
  },
  loadIfLive: function() {
    var self = this
    window.setInterval(function() {
      api.checkisBroadcasting(self.broadcaster.ssId, function(isBroadcasting) {
        self.broadcaster.isBroadcasting = isBroadcasting
        if (isBroadcasting) {
          self.loadLiveBroadcast()
        }
      })
    }, 90000)
  },
  loadLiveOnlyPlayer: function() {
   //debug('BD loadLiveOnlyPlayer Function called')
    if (this.broadcaster.isBroadcasting && !this.qs.autoPlay) {
      this.state = 'live'
      this.toggleHomeOverlay('show')
      //this.toggleLiveWatermark('show')
    } else if (this.broadcaster.isBroadcasting) {
      this.overlay.last = 'video'
      this.state = 'liveAndBroadcasting'
      this.toggleHomeOverlay('hide')
      //this.toggleLiveWatermark('show')
      Player.currentVideo = {
        //custom_name: this.broadcaster.name + ' Live Broadcast',
        custom_name: this.liveBroadcastTitle,
        //liveCaptionFile: this.liveCaptionFile,
        src: this.broadcaster.live_src,
        live: true,
        type: 'application/x-mpegurl'
      }
      //is this the workflow for locked events that have the passcode?  No idea
      if (this.lock.isPrivate && window.localStorage.getItem('locked' + this.lock.eventId) !== 'true') {
        var self = this
        var video = {
          //custom_name: this.broadcaster.name + ' Live Broadcast',
          custom_name: this.liveBroadcastTitle,
          //liveCaptionFile: this.liveCaptionFile,
          src: this.broadcaster.live_src,
          live: true,
          type: 'application/x-mpegurl'
        }
        if (window.Player.mobile) {
         //debug('BD mobile detected, pause called via API')
          self._play(video, function() {
            self.api.pause()
            self.lockEvent(self.lock, null, function() {
              Player.currentVideo = video
              self.state = 'liveAndBroadcasting'
              self.api.play()
            })
          })
        } else {
          this.lockEvent(this.lock, null, function() {
            Player.currentVideo = video
            self.state = 'liveAndBroadcasting'
            self._play(video, function() {
              if (window.Player.os === 'iOS') {
                $(this.flowplayerId).removeClass('is-splash')
                $(this.flowplayerId).addClass('is-loading')
                setTimeout(function() {
                  self.api.stop()
                  $(this.flowplayerId).removeClass('is-loading')
                }, 1000)
              }
            })
          })
        }
      }
    } else if (!this.broadcaster.isBroadcasting) {
      this.state = 'liveAndNotBroadcasting'
      /** disabled this check in FP7, may use this for check for lock in future
      this.loadIfLive()
      **/
      this.toggleHomeOverlay('show')
    }
  },
  loadDefaultPlayer: function() {
   //debug('BD loadDefaultPlayer function called')
    //this.qs.playerDescription = 'Default player for ' + this.broadcaster.name
    if (this.qs['autoPlay'] && this.broadcaster.isBroadcasting && !this.mobile) {
      this.state = 'liveAndBroadcasting'
      this.loadLiveStatic()
      //this.toggleLiveWatermark('show')
    } else {
      this.state = 'archive'
      this.toggleHomeOverlay('show')
      //this.appendLiveButton()
    }
  },
  play: function(video) {
   //debug('BD play function called')
    var self = this
    this.state = 'video'
    this.overlayUpdate('video')
    this.overlayTrigger('video')
    this.toggleMenu('hide')
    Player.currentVideo = video
    if (parseInt(video.private) && !window.localStorage.getItem('locked' + video.idHash)) {
      this.lockVod(video, this._play.bind(this, video, function() {
        if (window.Player.os === 'iOS') {
          $(this.flowplayerId).removeClass('is-splash')
          $(this.flowplayerId).addClass('is-loading')
          setTimeout(function() {
            self.api.stop()
            $(this.flowplayerId).removeClass('is-loading')
          }, 1000)
        }
      }))
    } else {
      this._play(video)
    }
  },
  //used to load VOD assets
  _play: function(video, cb) {
   //debug('BD _play function called with video %j',video)
    if (!cb) {
      cb = function() {}
    }

    /** disabling for Gen3 release where hlsjs is required to show bitrate selector for Safari
    if (typeof video.file_id !== 'undefined' && this.isSafari ) {
      //debug('updating safariHLSJS to false for VOD')
      this.api.conf.hlsjs.safari = false
    }
    **/


    var clip = this.getBasePlayerClip(video)
    this.api.conf.clip = clip
    this.api.load(clip, cb)
    this.emitter.emit('play', video)
  },
  loadLiveStatic: function() {
   //debug('BD loadLiveStatic function called')
    var self = this
    var locked = this.lock.isPrivate && window.localStorage.getItem('locked' + self.lock.eventId) !== 'true'
    if (this.state == 'liveAndBroadcasting' && !locked) {
      this.toggleLiveWatermark('show')
      return
    }
    $('.fp-live-broadcasting').hide()
    $('#play-overlay').hide()
    $('.menu-link.watch-live-broadcast').hide()
    var clip = this.getBasePlayerClip({
      //custom_name: this.broadcaster.name + ' Live Broadcast',
      custom_name: this.liveBroadcastTitle,
      //liveCaptionFile: this.liveCaptionFile,
      enableDVR: this.enableDVR,
      //src: this.broadcaster.live_src, //replace with currentLive
      src: this.liveManifest,
      live: true
    })
    $('ui#video-list a').click(function() {
      this.state = ''
    })
    var video = {
      //custom_name: this.broadcaster.name + ' Live Broadcast',
      custom_name: this.liveBroadcastTitle,
      //liveCaptionFile: this.liveCaptionFile,
      src: this.broadcaster.live_src,
      live: true,
      type: 'application/x-mpegurl'
    }
    if (this.lock.isPrivate && window.localStorage.getItem('locked' + self.lock.eventId) !== 'true') {
      if (window.Player.mobile) {
        self._play(video, function() {
          self.api.pause()
          self.lockEvent(self.lock, null, function() {
            Player.currentVideo = video
            self.state = 'liveAndBroadcasting'
            self.toggleLiveWatermark('show')
            self.api.play()
          })
        })
      } else {
        this.lockEvent(this.lock, null, function() {
          Player.currentVideo = video
          self.state = 'liveAndBroadcasting'
          self.toggleLiveWatermark('show')
          /* removed for Gen3 Platform, may cause issues with iOS playback
          self._play(video, function() {
            if (window.Player.os === 'iOS') {
              $(self.flowplayerId).removeClass('is-splash')
              $(self.flowplayerId).addClass('is-loading')
              setTimeout(function() {
                self.api.stop()
                $(self.flowplayerId).removeClass('is-loading')
              }, 1000)
            }
          }) */
          self.emitter.emit('play', video)
         //debug('BD loadLiveStatic function, api load clip: ' + JSON.stringify(clip))
          self.api.load(clip)
          self._play(video, function() {
            if (window.Player.os === 'iOS') {
              $(self.flowplayerId).removeClass('is-splash')
              $(self.flowplayerId).addClass('is-loading')
              setTimeout(function() {
                self.api.stop()
                $(self.flowplayerId).removeClass('is-loading')
              }, 1000)
            }
          })
        })
      }
    } else {
      Player.currentVideo = video
      self.state = 'liveAndBroadcasting'
      self.toggleLiveWatermark('show')
      self.emitter.emit('play', video)
     //debug('BD loadLiveStatic function, api load clip: ' + JSON.stringify(clip))
      self.api.load(clip)
    }
  },
  loadLiveBroadcast: function() {
   //debug('BD loadLiveBroadcast function called')
    var self = this
    var locked = this.lock.isPrivate && window.localStorage.getItem('locked' + self.lock.eventId) !== 'true'
    if (this.state == 'liveAndBroadcasting' && !locked) {
      //this.toggleLiveWatermark('show')
      return
    }
    //doublecheck that they are indeed broadcasting
    api.checkisBroadcasting(self.broadcaster.ssId, function(isBroadcasting) {
      if( isBroadcasting ){
        //update the broadcast to ensure we have correct data
        self.updateBroadcaster(self.broadcaster.ssId, function(data) {
          self.broadcaster = data
          $('.fp-live-broadcasting').hide()
          $('#play-overlay').hide()
          $('.menu-link.watch-live-broadcast').hide()

          var clip = self.getBasePlayerClip({
            //custom_name: self.broadcaster.name + ' Live Broadcast',
            custom_name: self.liveBroadcastTitle,
            enableDVR: self.enableDVR,
            //liveCaptionFile: this.liveCaptionFile,
            //src: self.broadcaster.live_src, //replace with currentLive
            src: self.liveManifest,

            live: true
          })
          $('ui#video-list a').click(function() {
            self.state = ''
          })
          /**
          //define Safari HLSJS only if MBR & live
          var safariHLSJS = false
          if( self.broadcaster.isBroadcasting && self.broadcaster.isMBR ){
            safariHLSJS = true
          }
          var hlsjs = self.getHlsConfig(true,safariHLSJS)
          debug('updating HLSJS for LIVE to %j', hlsjs)
          self.api.conf.hlsjs = hlsjs
          **/

          var video = {
            //custom_name: self.broadcaster.name + ' Live Broadcast',
            custom_name: self.liveBroadcastTitle,
            //liveCaptionFile: this.liveCaptionFile,
            src: self.broadcaster.live_src,
            live: true,
            type: 'application/x-mpegurl'
          }

          if (self.lock.isPrivate && window.localStorage.getItem('locked' + self.lock.eventId) !== 'true') {
            if (window.Player.mobile) {
             //debug('BD Mobile detected pause called via API')
              self._play(video, function() {
                self.api.pause()
                self.lockEvent(self.lock, null, function() {
                  Player.currentVideo = video
                  self.state = 'liveAndBroadcasting'
                  //self.toggleLiveWatermark('show')
                  self.api.play()
                })
              })
            } else {
              self.lockEvent(self.lock, null, function() {
                Player.currentVideo = video
                self.state = 'liveAndBroadcasting'
                //self.toggleLiveWatermark('show')
                self._play(video, function() {
                  if (window.Player.os === 'iOS') {
                    $(self.flowplayerId).removeClass('is-splash')
                    $(self.flowplayerId).addClass('is-loading')
                    setTimeout(function() {
                      self.api.stop()
                      $(self.flowplayerId).removeClass('is-loading')
                    }, 1000)
                  }
                })
              })
            }
          } else {
            Player.currentVideo = video
            self.state = 'liveAndBroadcasting'
            self.toggleLiveWatermark('show')
            self.emitter.emit('play', video)
           //debug('BD loadLiveBroadcast function, api load clip: ' + JSON.stringify(clip))
            self.api.conf.clip = clip
            self.api.load(clip)
            //this.emitter.emit('play', video)
            //self.api.load(clip)
          }
         //debug('BD end of function')
        });
      } else {
       //debug('BD isBroadcasting is false, loading error overlay')
        var text = 'Error Playing Live Broadcast'
        var errorDetailText = 'This broadcast has either ended or has been temporarily disrupted (error #103)'
        self.toggleInfoOverlay('show', text, errorDetailText, ['.action-refresh-page'])
      }
    });
  },
  appendCategoryDropdown: function() {
    $('#player-archive-category-select').append('<select class="form-control " id="catSel"></select>')
      //$("select#catSel").dropdown()
    $('select#catSel').change(function() {
      var catSelected = $('select#catSel option:selected').val()
      $('.ondemand').each(function() {
        if ($(this).hasClass(catSelected)) {
          $(this).fadeIn(500)
        } else {
          $(this).fadeOut(300)
        }
      })
    })

    $('#catSel').append('<option value="ondemand" selected>All Categories</option>')
    var option = ''
    for (var i = 0; i < this.usedCategories.length; i++) {
      option += '<option value="' + this.usedCategories[i].catId + '">' + this.usedCategories[i].catName + '</option>'
    }
    $('#catSel').append(option)
  },
  getHlsConfig: function(override, safariHLSJS) {
   //debug('BD: getHlsConfig function called, safariHLSJS set to: ' + safariHLSJS)
    var hlsConfig = {
      recoverMediaError: true,
      listeners: ['hlsError','hlsLevelSwitch'],
      smoothSwitching: true,
      strict: false,
      safari: safariHLSJS
    }

    if (override) return hlsConfig
    //if (!this.broadcaster.aac && !override) return false
    return hlsConfig
  },
  generateBasePlayerConfig: function() {
   //debug('BD generateBasePlayerConfig function called')
    var locked = this.lock.isPrivate && window.localStorage.getItem('locked' + this.lock.eventId) !== 'true'
    var autoPlay = this.qs.autoPlay && !locked && this.broadcaster.isBroadcasting
    //debug('autoplay: ' + autoPlay);

    /** disabling for Gen3 release where hlsjs is required to show bitrate selector for Safari **/
    var safariHLSJS = true
    if( this.broadcaster.isBroadcasting && this.broadcaster.isMBR ){
      safariHLSJS = true
    }

    var base = {
      key: '$777560046865207',
      splash: true,
      keyboard: false,
      embed: false,
      native_fullscreen: true,
      adaptiveRatio: true,
      fullscreen: true,
      ratio: 9 / 16,
      share: false,
      brand: false,
      analytics: null,
      chromecast: false,
      hlsjs: this.getHlsConfig(true, safariHLSJS),
      debug: false,
      nativesubtitles: true
    }

    if( this.qs.chromecast ){
      //debug('updating chromecast to true');
      base = _.extend(base, {
        chromecast: true
      })
    } else if( this.flowplayerId == '#ss-player' ){
      //debug('updating chromecast to true for venue page');
      base = _.extend(base, {
        chromecast: true
      })
    }

    if( this.broadcaster.googleTrackingId ){
     //debug('BD adding analytics to player using ID %s',this.broadcaster.googleTrackingId)
      base = _.extend(base, {
        analytics: this.broadcaster.googleTrackingId
      })
    }

    if (this.qs.video) {
      return _.extend(base, {
        clip: this.getBasePlayerClip(this.video),
        advance: false,
        autoplay: false
      })
    } else {
      return _.extend(base, {
        clip: this.getBasePlayerClip({
          custom_name: this.broadcaster.name + ' Live Broadcast',
          //src: this.broadcaster.live_src, //replace with currentLive
          src: this.liveManifest,
          enableDVR: this.enableDVR,
          live: true
        }),
        advance: false,
        splash: !autoPlay,
        autoplay: autoPlay
      })
    }
  },
  overlayUpdate: function(newContext) {
    //debug('BD overlayUpdate function called with context %j',newContext)
    this.baseOverlay.off()
    this.baseOverlay.show()
    if( this.overlay.now != 'archives' && this.overlay.now != 'info' && this.overlay.now != 'schedule'){
      this.overlay.last = this.overlay.now
    } else {
     //debug('BD bypassig this.overlay.last update for: ' + this.overlay.now  + ', keeping: ' + this.overlay.last)
    }
    this.overlay.now = newContext
  },
  /**
   * Show/Hide Home overlay
   * @param  {string} display show or hide
   * @return {null}
   */
  toggleHomeOverlay: function(display) {
    var playerEl = $(this.flowplayerId)
    if (display === 'hide') {
      this.baseOverlay.off('click.play-action')
      this.toggleBackgroundOverlay('hide')
      playerEl.removeClass('no-toggle')
      this.hideOverlay()
    } else if (display == 'show') {
      this.overlayUpdate('home')
      playerEl.addClass('no-toggle')
      this.baseOverlay.removeClass().addClass('home-overlay')
      var homeEl = $('.home-overlay')
      var template = require('./templates/home-overlay.ejs')
      var html = template()
      homeEl.html(html)
      homeEl.show()
      this.playOverlay.show()
      if (this.mobile) {
        //temporarily disabling
        //homeEl.find('.player-control .fp-progress').hide()
      }
      //this.qs.liveOnly ? this.toggleHomeMenuButton('hide') : this.toggleHomeMenuButton('show')
      this.toggleBackgroundOverlay('show')
      this.determinePlayAction()
      //this.appendCountdown(homeEl) // player-countdown
      this.helperFunctions(homeEl) // Make sure these don't run every time.
      this.registerActions()
     //debug('BD end of toggle Home Overlay function')
    }
  },
  determinePlayAction: function() {
    var self = this
   //debug('BD determinePlayAction function called')
    if ( this.qs.category ){
      //it is a category player, have to start with this as it will not have live integration
      $('.live-badge').hide()
      $('.home-overlay').off('click.info').on('click.info', function() {
        self.toggleArchivesOverlay('show')
      })
    } else if (this.broadcaster.isBroadcasting) {
      $('.home-overlay').addClass('watch-live-broadcast')
      $('.live-badge').show()
      //this.toggleLiveWatermark('show')
    } else if (this.disableMenu) {
      $('.home-overlay').off('click.info').on('click.info', function() {
        var text = self.broadcaster.name + ' is not broadcasting right now.'
        self.toggleInfoOverlay('show', text, '', ['.action-toggle-home'])
      })
    } else {
      /**
      $('.home-overlay').off('click.play-action').on('click.play-action', function() {
        self.toggleMenu('toggle')
      }) **/
      $('.home-overlay').off('click.info').on('click.info', function() {
        //adding isBroadcasting check here
        api.checkisBroadcasting(self.broadcaster.ssId, function(isBroadcasting) {
          self.broadcaster.isBroadcasting = isBroadcasting
          if (isBroadcasting && self.state !== 'liveAndBroadcasting' && self.state !== 'locked' && !self.audioOnly) {
            //load the live broadcast
           //debug('BD homeOverlayClick resulted in live-broadcast, loadingLiveBroadcast')
            if( self.isSafari ){
             //debug('BD homeOverlayClick resulted in live-broadcast, refreshing player for Safari until 7.2.2 fixes issues')
              window.location.reload()
            }
            self.loadLiveBroadcast()
          } else {
            var text = self.broadcaster.name + ' is not broadcasting right now.'
            self.toggleInfoOverlay('show', text, '', ['.action-toggle-home'])
          }
        })
      })
    }
  },
  emailSignUp: function() {
    var self = this
    $('.signup-overlay-segment').flowtype()
    $('.signup-overlay-segment .signup-feedback').hide()
    $('form#signup-form').submit(function(e) {
      e.preventDefault()
      $('.signup-overlay-segment .signup-feedback').hide()
      var emailAddress = $('#signup-email').val()
      var emailFirstName = $('#signup-firstname').val()
      var emailLastName = $('#signup-lastname').val()
      if (_.isEmpty(emailFirstName) || _.isEmpty(emailFirstName) || _.isEmpty(emailLastName)) {
        $('.signup-overlay-segment .signup-feedback').show()
        $('.signup-overlay-segment .signup-feedback').addClass('alert-danger')
        $('.signup-overlay-segment .signup-feedback').text('Please fill out all fields')
        return false
      }
      $.ajax({
        type: 'GET',
        url: '/email/subscribe?ssId=' + self.broadcaster.ssId + '&venue=' + self.broadcaster.name + '&email=' + emailAddress + '&firstName=' + emailFirstName + '&lastName=' + emailLastName,
        data: '',
        success: function(data) {
          data = JSON.parse(data)
          if (!data.error) {
            $('.signup-overlay-segment .signup-feedback').show()
            $('.signup-overlay-segment .signup-feedback').text('You have successfully subscribed to weekly schedule emails for this broadcaster')
            $('form#signup-form').hide()
          } else {
            $('.signup-overlay-segment .signup-feedback').show()
            $('.signup-overlay-segment .signup-feedback').text('It looks like something went wrong: ' + data.errorText)
          }
        }
      })
      return false
    })
  },
  appendMenu: function() {
   //debug('BD appendMenu function called, loading menu.ejs template')
    if (this.disableMenu) return
    if(!this.menu){
      var menuTemplate = require('./templates/menu.ejs')
      var html = menuTemplate()
      $('#content').append(html)
     //debug('BD temporarily disabling the creation of slideout menu object')
      this.menu = true
      /**
      this.menu = new slideout({
        'panel': $('.slideout-panel')[0],
        'menu': $('#menu')[0],
        'side': 'right',
        'padding': 337,
        'tolerance': 70
      }) **/
    }
    if(this.qs.category){
      this.appendMenuHome()
      this.appendCategoryArchiveList()
      this.toggleMenuCategoryArchiveView('show')
    } else{
      this.toggleMenuLoading('show')
      if ((this.qs.showRecentArchives || this.qs.showArchives ) && !this.videos) {
        this.getVideos(this.appendMenu.bind(this))
        return
      }
      this.appendMenuHome()
      this.getUpcomingBroadcasts(function() {
        if (this.qs.showSchedule) this.appendUpcomingBroadcasts()
        if (this.qs.showMenuCountdown) this.appendMenuLiveCountdown()
      }.bind(this))
      if (this.qs.showRecentArchives) this.appendRecentArchives()
      if (this.qs.showArchives) this.appendArchiveList()
    }
    this.helperFunctions($('#menu'))
    this.registerActions()
  },
  toggleMenuLoading(display){
   //debug('BD toggleMenuLoading Function called with action %s',display)
    if (display === 'show') {
      $('#menu header').hide()
      var loadingTempalte = require('./templates/loading.ejs')
      var html = loadingTempalte()
      $('#menu').append(html)
      $('#menu .loading').show()
    } else if (display == 'hide') {
      $('#menu header').fadeIn()
      $('#menu .loading').hide()
    }
  },
  toggleMenuUpcomingBroadcast: function(display) {
    if (display === 'hide') {
      $('.upcoming-broadcast-section').hide()
    } else if (display == 'show') {
      if (this.qs.showSchedule) {
        $('.upcoming-broadcast-section').show()
      }
    }
  },
  toggleMenuNav: function(display) {
    if (display === 'hide') {
      $('.menu-nav-section').hide()
    } else if (display == 'show') {
      $('.menu-nav-section').show()
    }
  },
  appendMenuHome: function() {
   //debug('BD appendMenuHome called, populates menu-home.ejs')
    this.toggleMenuLoading('hide')
    var menuTemplate = require('./templates/menu-home.ejs')
    var html = menuTemplate()
    $('#menu').append(html)

    if( this.broadcaster.brandingId != null && this.branding != null ){
        debug('changing menu logo to ' + this.branding.brandPlayerMenu)
        $('#menu-header-img').attr('src', this.branding.brandPlayerMenu)
        //update click link
        debug('changing link to ' + this.branding.brandLink)
        $("#playerExternalLink").attr("href", this.branding.brandLink)
        debug('updating product title to ' + this.branding.brandName)
        debug('updating terms and privacy to ' + this.branding.brandTerms +  ' '  + this.branding.brandPrivacy)

        //update the links
        $("#menu-terms-of-use").attr("href", this.branding.brandTerms)
        $("#menu-privacy-policy").attr("href", this.branding.brandPrivacy)
        $("#menu-product-name").text(this.branding.brandName)
        $("#menu-parent-company").text(this.branding.brandName)
    }

    if (!this.qs.showSubscribe) {
      $('.subscribe-to-broadcast').hide()
    }
    /** decommissioned with FP7 by BCD

    if (this.qs.showDonate && parseInt(this.broadcaster.isDonate)) {
      this.appendMenuDonateView()
    } else {
      $('#menu-donate').hide()
    }
    $('#menu-donate').hide()
    if (this.qs.showRoku && parseInt(this.broadcaster.isRoku)) {
      this.appendRoku()
    } else {
      $('#menu-roku').hide()
    }
    if (!(this.broadcaster.is_chat && this.broadcaster.isBroadcasting)) {
      $('#menu-live-chat').hide()
    }
    **/
    if (!this.qs.showArchives || _.isEmpty(this.videos)) {
      $('#menu-archive-list').hide()
    }
    this.toggleMenuHome('show')
  },
  appendMenuDonateView: function() {
    $('.donate-section .donate-wrapper').html($('<textarea/>').html(this.broadcaster.donate).text())
  },
  appendRoku: function() {
    $('#menu-roku')
      .attr('href', 'https://streamspot.com/watch-on-roku?venue=' + this.broadcaster.ssId)
      .attr('target', '_blank')
  },
  toggleMenuDonateView: function(display) {
    if (display === 'hide') {
      $('.donate-section').hide()
    } else if (display == 'show') {
      this.toggleMenuBackButton('show')
      this.toggleMenuCountdown('hide')
      this.toggleMenuAboutView('hide')
      this.toggleMenuUpcomingBroadcast('hide')
      this.toggleMenuRecentArchives('hide')
      this.toggleMenuArchiveView('hide')
      this.toggleMenuNav('hide')
      $('.donate-section').show()
    }
  },
  toggleMenuAboutView: function(display) {
    if (display === 'hide') {
      $('.about-steamspot-section').hide()
    } else if (display == 'show') {
      this.toggleMenuBackButton('show')
      this.toggleMenuCountdown('hide')
      this.toggleMenuUpcomingBroadcast('hide')
      this.toggleMenuRecentArchives('hide')
      this.toggleMenuArchiveView('hide')
      this.toggleMenuNav('hide')
      $('.about-steamspot-section').show()
    }
  },
  toggleContextMenu: function() {
    //debug('BD toggleContextMenu Function called')
    $('.fp-context-menu').removeClass('fp-active')
  },
  toggleMenuBackButton: function(display) {
    if (display === 'hide') {
      $('.back-to-home-section').hide()
    } else if (display == 'show') {
      $('.back-to-home-section').show()
    }
  },
  toggleMenuHome: function(display) {
    if (display === 'hide') {
      this.toggleMenuUpcomingBroadcast('hide')
      this.toggleMenuRecentArchives('hide')
      this.toggleMenuNav('hide')
      this.toggleMenuCountdown('hide')
    } else if (display == 'show') {
      ChatBox.unmount()
      this.toggleMenuLiveChat('hide')
      this.toggleMenuCountdown('show')
      this.toggleMenuAboutView('hide')
      this.toggleMenuBackButton('hide')
      this.toggleMenuDonateView('hide')
      this.toggleMenuArchiveView('hide')
      this.toggleMenuUpcomingBroadcast('show')
      this.toggleMenuRecentArchives('show')
      this.toggleMenuArchives('show')
      this.toggleMenuNav('show')
    }
  },
  toggleMenuCategoryArchiveView: function(display) {
    if (display === 'hide') {
      $('.category-list-section').hide()
    } else if (display == 'show') {
      this.toggleMenuDonateView('hide')
      this.toggleMenuCountdown('hide')
      this.toggleMenuAboutView('hide')
      this.toggleMenuBackButton('hide')
      this.toggleMenuUpcomingBroadcast('hide')
      this.toggleMenuRecentArchives('hide')
      this.toggleMenuNav('hide')
      $('.category-list-section').show()
      $('#category-video-list').liveFilter('#category-video-list-filter', 'li', {
        filterChildSelector: 'div.search-div'
      })
    }
  },
  toggleMenuArchiveView: function(display) {
   //debug('BD toggleMenuArchiveView function called with action %s',display)
    if (display === 'hide') {
      //$('.archive-list-section').hide()
    } else if (display == 'show') {
      this.toggleMenuDonateView('hide')
      this.toggleMenuCountdown('hide')
      this.toggleMenuAboutView('hide')
      this.toggleMenuBackButton('show')
      this.toggleMenuUpcomingBroadcast('hide')
      this.toggleMenuRecentArchives('hide')
      this.toggleMenuNav('hide')
    }
  },
  toggleMenuLiveChat: function(display) {
    if (display === 'hide') {
      $('.live-chat-section').hide()
    } else if (display == 'show') {
      this.toggleMenuDonateView('hide')
      this.toggleMenuCountdown('hide')
      this.toggleMenuArchiveView('hide')
      this.toggleMenuAboutView('hide')
      this.toggleMenuBackButton('show')
      this.toggleMenuUpcomingBroadcast('hide')
      this.toggleMenuRecentArchives('hide')
      this.toggleMenuNav('hide')
      $('.live-chat-section').show()
      ChatBox.render('live-chat', {
        church: this.broadcaster.ssId,
        popout: true
      })
    }
  },
  toggleMenuRecentArchives: function(display) {
    if (display === 'hide') {
      $('.recent-archives-section').hide()
    } else if (display == 'show') {
      if (this.qs.showRecentArchives && !_.isEmpty(this.videos)) {
        $('.recent-archives-section').show()
      } else {
        $('.recent-archives-section').hide()
      }
    }
  },
  toggleMenuArchives: function(display) {
    if (display === 'hide') {
      $('#menu-archive-list').hide()
    } else if (display == 'show') {
      if (this.qs.showArchives) {
        $('#menu-archive-list').css('display', 'block')
      } else {
        this.toggleMenuArchives('hide')
      }
    }
  },
  appendUpcomingBroadcasts: function() {
    var self = this
    var broadcastListItemTemplate = require('./templates/broadcast-list-item.ejs')
    if (!this.broadcasts) {
      this.getUpcomingBroadcasts(this.appendUpcomingBroadcasts.bind(this))
      return
    }
   //debug('BD appendUpcomingBroadcasts function called for broadcaster %s', self.broadcaster.name)
    var broadcasts = this.broadcasts
    if (_.isEmpty(broadcasts)) {
      broadcastListItemTemplate = require('./templates/no-broadcast-list-item.ejs')
      var html = broadcastListItemTemplate()
      $('ul.broadcast-list').append(html)
    } else {
      var broadcastsToShow = _.filter(broadcasts, {
        'exclude': 0,
        'skip': 0
      }).slice(0, 7)
      _.each(broadcastsToShow, function(broadcast, index) {
        broadcast.googleCalenderLink = util.generateGoogleCalLink(broadcast, self.broadcaster)
        //set displayVars
        broadcast.scheduleMonth = moment(broadcast.start).format('MMM');
        broadcast.scheduleDay = moment(broadcast.start).format('DD');
        broadcast.scheduleTime = moment(broadcast.start).format('hh:mmA');

        var html = broadcastListItemTemplate(broadcast)
        html = $(html).attr('data-index', index)
        $('ul.broadcast-list').append(html)
      })
    }
  },
  appendRecentArchives: function() {
    var self = this
    var videoListItemTemplate = require('./templates/video-list-item.ejs')
    if (!this.videos) {
      this.getVideos(this.appendRecentArchives.bind(this))
      return
    }
    if (_.isEmpty(this.videos)) {
      this.toggleMenuRecentArchives('hide')
      return
    }
    var videos = _.cloneDeep(this.videos.slice(0, 5))
    _.each(videos, function(video) {
      var vidDur = moment().startOf('day').seconds(video.duration).format('H:mm:ss')
      video.vidDur = vidDur
      //video.duration = vidDur
      if(_.isEmpty(video.thumbnailLink)){
        video.thumbnailLink = 'https://cdn2.streamspot.com/streamspot-od-w-circles-160x90.png'
      }
      var html = videoListItemTemplate(video)
      var videoEl = $(html)
      $(videoEl).click(function(e) {
        e.preventDefault()
        self.state = 'vod'
        //self.toggleLiveWatermark('hide')
        self.currentVideo = video
        self.currentVideo.type = 'application/x-mpegurl'
        self.play(video)
      })
      $('ul.recent-archive-video-list').append(videoEl)
    })
    //$('img.video-image').unveil()
    //$('.recent-archive-video-list img.video-image').trigger('unveil')
  },

  appendArchiveList: function(broadcastQuery) {
    var self = this
    if (typeof broadcastQuery == 'undefined') {
      broadcastQuery = 'empty'
    }
    if (!this.videos) {
      this.getVideos(this.appendArchiveList.bind(this))
      return
    }
    if (!this.categories) {
      this.getCategories(this.appendArchiveList.bind(this))
      return
    }
   //debug('BD appendArchiveList function called with query %s ',broadcastQuery)
    var videoListItemTemplate = require('./templates/video-list-item.ejs')
    if (_.isEmpty(this.videos) || !this.qs.showArchives) {
      this.qs.showArchives = 0
      //this.toggleMenuArchiveView('hide')
      return
    }

   //debug('BD truncating archive list for empty query')
    $('#video-list').html('')
    $('.owl-carousel').trigger('destroy.owl.carousel');
    $('.owl-carousel').html($('.owl-carousel').find('.owl-stage-outer').html()).removeClass('owl-loaded');

    var archiveCount = 0
    //set limit for how many archives can be shown
    var archiveLimit = 30
    //for loop that populates the archives in the player from the API information above
    _.each(self.videos, function(video) {
      if( archiveCount < archiveLimit ){
        var vidDur = moment().startOf('day').seconds(video.duration).format('H:mm:ss')
        video.vidDur = vidDur
        //video.duration = vidDur
        if(_.isEmpty(video.thumbnailLink)){
          video.thumbnailLink = 'https://cdn2.streamspot.com/streamspot-od-w-circles-160x90.png'
        }
        if( video.custom_name ){
          video.titleForAria = video.custom_name
        } else {
          video.titleForAria = video.date + ' ' + video.time
        }
        var html = videoListItemTemplate(video)
        var videoEl = $(html)
        videoEl.addClass('ondemand')
        if (video.category !== '0' && video.category !== 0) {
          // Add the categoryId  as a class
          videoEl.addClass(video.category.toString())
            // Add to list of used categories, only if it's not there
          if (_.isEmpty(_.filter(self.usedCategories, {
            'catId': parseInt(video.category)
          }))) {
            var cat = _.filter(self.categories, {
              'catId': parseInt(video.category)
            })[0]
            self.usedCategories.push(cat)
          }
        }
        $(videoEl).click(function() {
          self.state = 'vod'
          self.currentVideo = video
          //self.toggleLiveWatermark('hide')
          self.currentVideo.type = 'application/x-mpegurl'
          self.play(video)
        })
        //if broadcastQuery is set, try to match the name
        if( broadcastQuery != 'empty' ){
          if( video.custom_name ){
            var queryMatch = video.custom_name.search(new RegExp(broadcastQuery, "i"))
            if( queryMatch >= 0 ){
              $('#video-list').append(videoEl)
              archiveCount++
            }
          }
          //show the reset button
          $('#filter-reset-btn').show()
        } else {
          $('#video-list').append(videoEl)
          archiveCount++
        }
      }
    })

    if( archiveCount ){
      //debug('defining the owl carousel with ' + archiveCount  + ' archives')
      //define the owl-carousel
      $('.owl-carousel').owlCarousel({
        margin:30,
        lazyLoad: true,
        responsiveClass:true,
        navText: ['<i class="fa fa-arrow-left"></i>','<i class="fa fa-arrow-right"></i>'],
        responsive:{
            0:{
                items:2,
                dots: false,
                nav: false,
            },
            480:{
                items:3,
                nav: false,
            },
            630:{
              nav: true,
              items:3,
            },
            768:{
                items:4,
                nav: true,
            },
            1024:{
                items:5,
                nav: true,
            }
        }
      })
      $('#noArchives').hide()
    } else {
      $('#noArchives').show()
    }
    if (_.isUndefined(this.qs.category)) {
      this.appendCategoryDropdown()
    }
  },
  appendCategoryArchiveList: function() {
    var self = this
    if (!this.videos) {
      this.getVideos(this.appendCategoryArchiveList.bind(this))
      return
    }
    var videoListItemTemplate = require('./templates/video-list-item.ejs')
    _.each(self.videos, function(video) {
      var vidDur = moment().startOf('day').seconds(video.duration).format('H:mm:ss')
      video.duration = vidDur
      var html = videoListItemTemplate(video)
      var videoEl = $(html)
      videoEl.addClass('ondemand')
      if (video.category !== '0' && video.category !== 0) {
        // Add the categoryId  as a class
        videoEl.addClass(video.category.toString())
          // Add to list of used categories, only if it's not there
        if (_.isEmpty(_.filter(self.usedCategories, {
          'catId': parseInt(video.category)
        }))) {
          var cat = _.filter(self.categories, {
            'catId': parseInt(video.category)
          })[0]
          self.usedCategories.push(cat)
        }
      }
      $(videoEl).click(function() {
        self.state = 'vod'
        self.currentVideo = video
        //self.toggleLiveWatermark('hide')
        self.currentVideo.type = 'application/x-mpegurl'
        self.play(video)
      })
      $('ul#category-video-list').append(videoEl)
    })
    //$('img.video-image').unveil()
    //$('.video-list img.video-image').slice(0, 10).trigger('unveil')
    $('#category-video-list').liveFilter('#category-video-list-filter', 'li', {
      filterChildSelector: 'div.search-div'
    })
  },
  populateUsedCategories: function(cb) {
    var self = this
    if (!this.categories) {
      this.getCategories(this.populateUsedCategories.bind(this, cb))
      return
    }
    if (_.isEmpty(this.videos)) return []
    _.each(this.videos, function(video) {
      if (video.category !== '0' && video.category !== 0) {
        // Add to list of used categories, only if it's not there
        if (_.isEmpty(_.filter(self.usedCategories, {
          'catId': parseInt(video.category)
        }))) {
          var cat = _.filter(self.categories, {
            'catId': parseInt(video.category)
          })[0]
          self.usedCategories.push(cat)
        }
      }
    })
    cb(self.usedCategories)
  },
  toggleBroadcastOverlay: function(display, broadcast) {
   //debug('BD toggleBroadcastOverlay called with display %s',display)
    if (display === 'hide') {
      $('#player-overlay').off('click.play-action')
      this.hideOverlay()
    } else if (display == 'show') {
      this.overlayUpdate('broadcast')
      $('#player-overlay').removeClass().addClass('broadcast-overlay')
      var template = require('./templates/broadcast-overlay.ejs')
      broadcast.googleCalenderLink = util.generateGoogleCalLink(broadcast, this.broadcaster)
      var html = template(broadcast)
      this.toggleMenu('hide')
      $('.broadcast-overlay').html(html)
      $('#play-overlay').hide()
      this.helperFunctions($('.broadcast-overlay')) // Make sure these don't run every time.
      this.registerActions()
    }
  },
  toggleFullScreenOverlay: function(display) {
    if (display === 'hide') {
      $('#player-overlay').off('click.play-action')
      this.overlay.last = 'video'
      this.hideOverlay()
    } else if (display == 'show') {
      this.overlayUpdate('fullscreen')
      $('#player-overlay').removeClass().addClass('fullscreen-overlay')
      var template = require('./templates/fullscreen-overlay.ejs')
      var link
      let baseUrl = 'https://venue.streamspot.com';
      if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
        baseUrl = 'https://testing-venue.streamspot.com'
      }
      if(this.currentVideo.live){
        link = `${baseUrl}/${this.broadcaster.ssId}?fullscreen=true`
      }else{
        link = `${baseUrl}/video/${this.currentVideo.idHash}?fullscreen=true`
      }
      var html = template({link})
      this.toggleMenu('hide')
      this.api.pause()
      $('.fullscreen-overlay').html(html)
      $('#play-overlay').hide()
      this.helperFunctions($('.fullscreen-overlay')) // Make sure these don't run every time.
      this.registerActions()
    }
  },
  toggleMenu: function(display) {
   //debug('BD toggleMenu function called with action: ' + display)
    var self = this
    if (this.disableMenu) return
    if ( !this.menu ) {
     //debug('BD menu hide called, but empty')
      if (display == 'hide'){
        $('#menu').hide()
        return
      }
      /** disable append menu, should not longer needed
      this.appendMenu() **/
    }
    //toggleMenuHome('show')
    if (display === 'hide') {
     //debug('BD close menu')
      //this.menu.close()
      $('#menu').hide()

    } else if (display == 'show') {
     //debug('BD show menu')
      //this.menu.open()
      $('#menu').show()

      if (this.overlay.now == 'live') {
       //debug('BD menu overlay now live called')
        $('.live-overlay').off('click.pause-action').on('click.pause-action', function() {
          self.toggleMenu('hide')
          $('.live-overlay').off('click.pause-action')
        })
      }
    } else if (display == 'toggle') {
     //debug('BD toggle menu')
      //this.menu.toggle()
      $('#menu').toggle()
    }
  },
  toggleInfoOverlay: function(display, text, errorDetailText, buttons) {
   //debug('BD toggleInfoOverlay function called with action %s', display)
   //debug('BD toggleInfoOverlay function called with text %s', text)
    if (display === 'hide') {
      $('#donateTag').html('')
      $('#donateTag').hide()
      $('#player-overlay').off('click.play-action')
      //show the toolbox
      //$('.fp-ss-toolbox').show()

      this.hideOverlay()
    } else {
      //hide the toolbox, if shown
      if($('.fp-ss-toolbox').length){
        $('.fp-ss-toolbox').hide();
      }
      var self = this
      this.overlayUpdate('info')
      if (_.isNull(text) ) {
        text = this.broadcaster.name + ' is not broadcasting right now.'
      }
      if(_.isNull(buttons) ){
        buttons = ['.action-toggle-home']
      }
      $('#player-overlay').removeClass().addClass('info-overlay')
      var template = require('./templates/info-overlay.ejs')
      var html = template()
      //hide all available divs
      $('#nextBroadcastDiv').hide()
      $('#errorDetailDiv').hide()
      $('.info-overlay').html(html)
      $('#play-overlay').hide()
      $('.info-overlay .info-text').text(text)
      var hasError = false
      if( errorDetailText != '' ){
        hasError = true
        $('#errorDetailDiv').show()
        $('.player-error-helper-class').text(errorDetailText)
        //hide the close button
        $('.info-overlay-close').hide()
      }
      $('.info-overlay button.btn').hide()
      $.each(buttons, function(index, button) {
        $(button).show()
      })
      if( !hasError ){
        //get next broadcast text
        this.determineNextBroadcast()
      }
      //if showArchives & showSchedue, show options
      if (!this.disableMenu && !hasError ) {
        $('#otherActionsDiv').show()
        if( !this.qs.showArchives ){
          //add the hide class
          $('.toolIconArchive').addClass('toolIconHidden')
        }
        if ( !this.qs.showDonate ) {
          $('.toolIconDonate').addClass('toolIconHidden')
        }
        if( !this.qs.showSchedule ){
          $('.toolIconSchedule').addClass('toolIconHidden')
        }
      }
      //start secondary actions for Info, donate, etc.
      if( display == 'showInfo'){
        //set the text to the broadcaster's name
        $('.info-overlay .info-text').text(this.broadcaster.name)
        //if not empty, put up what they're watching
        if( this.api.video.title != ''){
          $('.info-overlay .infoAuxText').text('Now Playing: ' + this.api.video.title)
        }
      }
      if ( display == 'showDonate' ){
        $('#nextBroadcastDiv').hide()
        $('#otherActionsDiv').hide()
        //set the text to the broadcaster's name
        $('.info-overlay .info-text').text('Donate to ' + this.broadcaster.name)
        //if not empty, put up what they're watching
        if( this.broadcaster.isDonate && this.broadcaster.donate != ''){
          $('#donateTag').html($('<textarea/>').html(this.broadcaster.donate).text())
        }
      }

      $('.info-overlay-close').click(function(event) {
        event.stopPropagation()
        self.toggleInfoOverlay('hide',null,'',null)
      })


      this.helperFunctions($('.info-overlay')) // Make sure these don't run every time.
      this.registerActions()
    }
  },
  toggleBackgroundOverlay: function(display) {
   //debug('BD toggleBackgroundOverlay function called with command: ' + display)
    if (display === 'hide') {
      $('#background-overlay').hide()
      $('#player-overlay').css('color', 'white')
    } else if (display == 'show') {
      var thumbnail
      if (this.qs.video) {
        thumbnail = this.video.thumbnailLink
        if ($('.flowplayer').width() >= 400) {
          thumbnail = this.video.thumbnailLinkHiRes
        }
        if (_.isEmpty(this.video.thumbnailLink)){
          thumbnail = 'https://d2i0qcc2ysg3s9.cloudfront.net/streamspot-player-bg-grey-1.jpg'
        }
       //debug('BD video background-overlay set to thumbnail: ' + thumbnail)
        $(this.flowplayerId).css('background-image', 'url("' + thumbnail + '")')
        //$('#background-overlay').show()
        $('#player-overlay').css('color', 'white')
      } else if (this.qs.branding && this.qs.showBg) {
        //temp check to update bg to new branding
        if( this.qs.bgLink == 'https://d2i0qcc2ysg3s9.cloudfront.net/streamspot-player-bg-blue-full-1280x720.jpg'
        || this.qs.bgLink == 'https://d2i0qcc2ysg3s9.cloudfront.net/streamspot_splash_player.jpg' ) {
         //debug('BD default background-overlay set to bg: ' + this.qs.bgLink)
          this.qs.bgLink = 'https://d2i0qcc2ysg3s9.cloudfront.net/streamspot-player-bg-grey-1.jpg'
          $(this.flowplayerId).css('background-image', 'url("' + this.qs.bgLink + '")')
        }
       //debug('BD player background-overlay set to bg: ' + this.qs.bgLink)
        //$('#player-overlay').css('color', 'black')
        //$('#background-overlay').css('background-image', 'url("' + this.qs.bgLink + '")')
        //$('#background-overlay').show()
        $(this.flowplayerId).css('background-image', 'url("' + this.qs.bgLink + '")')
      } else {
        $('#player-overlay').css('color', 'white')
      }
    }
    if (this.qs.textColor) {
     //debug('BD bypassing textColor %s',this.qs.textColor)
      //$('#player-overlay').css('color', this.qs.textColor)
    }
    if (this.qs['animateBg'] && !this.mobile) {
      $('#background-overlay').addClass('animate')
    }
  },
  toggleHomeMenuButton: function(display) {
    if (display === 'hide') {
      $('.player-overlay-archive-menu').hide()
    } else if (display == 'show') {
      $('.player-overlay-archive-menu').show()
    }
  },
  helperFunctions: function(parent) {
   //debug('BD helperFunctions called with parent: ' + JSON.stringify(parent, ['selector']))
    this.appendBroadcasterName(parent) // church-name
    this.appendPlayerVersion(parent) // player-version
    this.appendChurchDescription(parent) // church-description
    this.appendPlayerTitle(parent) // player-title
    this.appendPlayerThumbnail(parent) // player-thumbnail
    this.appendMenuButton() //adds menu to flowplayer header
    this.appendArchivesButton() //adds archive icon to flowplayer header
    this.appendVideoTitle() // player-video-title
  },
  appendVideoTitle: function() {
    if (_.isEmpty(this.videos) && !this.video) return
    var title
    if (this.api && this.api.video.title) {
      title = this.api.video.title
    } else {
      if (this.video) {
        title = this.video.custom_name || this.video.date + ' ' + this.video.time
      } else {
        title = this.videos[0].custom_name || this.videos[0].date + ' ' + this.videos[0].time
      }
    }
    $('.player-video-title').html(title)
  },
  toggleMenuWatching: function(display) {
   //debug('BD toggleMenuWatching function called, action %s',display)
    if (display === 'hide') {
      $('.menu-watching-section').hide()
    } else if (display == 'show') {
      $('.menu-watching-section').show()
    }
  },
  appendBroadcasterName: function(parent) {
    parent.find('.church-name').html(this.broadcaster.name)
  },
  appendPlayerTitle: function(parent) {
    if (!this.qs.showTitle) {
      //parent.find('.player-header').hide()
    }

    if (this.qs.showDesc && !this.qs.category){
      if (typeof this.qs.playerDescription !== 'undefined') {
        if( this.qs.playerDescription.indexOf("Default") !== -1 ){
          debug('BD bypassing inclusion of Default description: ' + this.qs.playerDescription)
        } else {
          if( this.qs.playerDescription.length ){
            parent.find('.player-title').append(' - ' + this.qs.playerDescription)
          }
        }
      }
    }
  },
  appendMenuButton: function() {
   //debug('BD disabling appendMenuButton function, in hopes of replacing')
    /**
    if (!this.disableMenu) {
      $('.player-menu').show()
      if(!$('.fp-archive-menu').length) {
        $('.fp-header').append('<a class="player-icon-button action-toggle-menu fp-archive-menu"></a>');
      }
    } else {
      $('.player-menu').hide()
      $('.player-overlay-archive-menu.action-toggle-menu.player-archive-link').hide()
    } **/
  },
  appendArchivesButton: function() {
   //debug('BD appendArchivesButton function called')
    //load the toolbox, regardless of archives, this is the starting point for all other icons as well
    if(!$('.fp-ss-toolbox').length ) {
      $('.fp-ui').append('<div class="fp-ss-toolbox"><ul class="tool-box toolbox-player vert"></ul></div>');
    }
    if ( !this.disableMenu ) {
        //$('.fp-ui').append('<div class="fp-ss-toolbox"><ul class="tool-box toolbox-player vert"></ul></div>');
        //put the live-now button on in a hidden state, unless live
        if( !$(".toolIconLive").length ){
          var liveToolboxIcon = require('./templates/liveToolBoxIcon.ejs')
          $('.toolbox-player').append(liveToolboxIcon)
        }
        //put the info button on
        if( !$(".toolIconInfo").length ){
          var infoToolboxIcon = require('./templates/infoToolBoxIcon.ejs')
          $('.toolbox-player').append(infoToolboxIcon)
        }
        if (this.qs.showArchives ) {
          if( !$(".toolIconArchive").length ){
            var archiveToolboxIcon = require('./templates/archiveToolBoxIcon.ejs')
            $('.toolbox-player').append(archiveToolboxIcon)
          }
        }
    }
  },
  toggleAudioOnlyButton: function(display) {
    debug('BD appendAudioOnlyButton function called with action %s:',display)
    if( display == 'show' || display == 'showVOD' ){
      if( !$(".toolIconAudioOnly").length ){
        var self = this
        var audioOnlyToolboxIcon = require('./templates/audioOnlyToolBoxIcon.ejs')
        $('.toolbox-player').append(audioOnlyToolboxIcon)
        //register the action
        if( display == 'showVOD' ){
          $('.action-toggle-audioOnly').off('click').on('click', function() {
            self.toggleAudioOnlyVOD();
          });
        } else {
          $('.action-toggle-audioOnly').off('click').on('click', function() {
            self.toggleAudioOnly();
          });
        }
      } else {
        //it's already there, just hidden
        $('.toolIconAudioOnly').removeClass('toolIconHidden')
        //re-register the action
        //register the action
        var self = this
        debug('re-registering action-toggle-audioOnly for %s:',display)
        if( display == 'showVOD' ){
          $('.action-toggle-audioOnly').off('click').on('click', function() {
            self.toggleAudioOnlyVOD();
          });
        } else {
          $('.action-toggle-audioOnly').off('click').on('click', function() {
            self.toggleAudioOnly();
          });
        }
      }
    } else {
      if( $(".toolIconAudioOnly").length ){
        $('.toolIconAudioOnly').addClass('toolIconHidden')
      }
    }
  },
  appendPlayerVersion: function(parent) {
    parent.find('.player-version').html(this.qs.version || 'beta')
  },
  appendPlayerThumbnail: function(parent) {
    if (this.qs.branding && this.qs.showThumb) {
      parent.find('.player-thumbnail').attr('src', this.qs.thumbLink)
    } else if (!this.qs.thumbnail) {
      parent.find('.player-thumbnail-wrapper').hide()
    } else {
      parent.find('.player-thumbnail').attr('src', '//cdn2.streamspot.com/streamspot-od-w-circles-160x90')
    }
  },
  appendChurchDescription: function(parent) {
   //debug('BD appendChurchDescription called')
      if(this.qs.category){
        parent.find('.player-title').html(this.category.catName)
        parent.find('.player-header').show()
        return
      }
  },
  determineNextBroadcast: function() {
   //debug('BD determineNextBroadcast function called')
    if (this.qs.countdown && !this.broadcaster.isBroadcasting && !this.qs.category) {
      if (!this.broadcasts) {
        this.getUpcomingBroadcasts(this.determineNextBroadcast.bind(this))
        return
      }
      if (this.next_broadcast) {
       //debug('BD nextBroadcastText: %s',this.next_broadcast.countdown_text)
        if( this.next_broadcast.countdown_text != "" ){
          //show the div on the info overlay
          $('#nextBroadcastDiv').show()
          //set the text to the next broadcast
          $("#nextBroadcastDiv span").text(this.next_broadcast.countdown_text)
        }
      }
    }
  },
  venuePageUpcomingBroadcasts: function() {
    if (!this.broadcasts) {
      this.getUpcomingBroadcasts(this.venuePageUpcomingBroadcasts.bind(this))
      return
    }
  },
  appendContextMenu: function() {
   //debug('BD appendContextMenu function called')
    var menuTemplate = require('./templates/context-menu.ejs')
    var html = menuTemplate()
    $(this.flowplayerId).append(html)
    if( this.broadcaster.brandingId != null && this.branding != null ){
        debug('changing menu logo to ' + this.branding.brandPlayerMenu)
        $('#menu-header-img').attr('src', this.branding.brandPlayerMenu)
        //update click link
        debug('changing link to ' + this.branding.brandLink)
        $("#playerExternalLink").attr("href", this.branding.brandLink)
        debug('updating product title to ' + this.branding.brandName)
        debug('updating terms and privacy to ' + this.branding.brandTerms +  ' '  + this.branding.brandPrivacy)

        //update the links
        $("#menu-terms-of-use").attr("href", this.branding.brandTerms)
        $("#menu-privacy-policy").attr("href", this.branding.brandPrivacy)
        $("#menu-product-name").text(this.branding.brandName)
    }
    //check for onelicense
    if( this.broadcaster.onelicenseId ){
      debug('BD: OneLicense ID: ' + this.broadcaster.onelicenseId)
      //add the venue name
      $("#onelicense-venue").text(this.broadcaster.name)
      //show the div
      $('#onelicense').show()
    } else if( this.broadcaster.jlicenseId ){
      debug('BD: JLicense ID: ' + this.broadcaster.jlicenseId)
      //add the venue name
      $("#jlicense-venue").text(this.broadcaster.name)
      //show the div
      $('#jlicense').show()
    }

    this.helperFunctions($(this.flowplayerId))
    this.registerActions()
  },
  registerActions: function() {
   //debug('BD registerActions called')

    const self = this;
    $('.action-toggle-signup').off('click').on('click', function(event) {
      event.stopPropagation();
      self.toggleMenu('hide');
      self.toggleSignupOverlay('show');
    });

    $('.action-toggle-menu').click(function(e) {
      e.stopPropagation();
      self.toggleMenu('show');
    });

    $('.action-toggle-archives').off('click').on('click', function() {
      self.toggleArchivesOverlay('show');
    });

    $('.action-toggle-schedule').off('click').on('click', function() {
      self.toggleScheduleOverlay('show');
    });

    $('.action-toggle-broadcast-info').off('click').on('click', function() {
      self.toggleInfoOverlay('showInfo', '', '', null);
    });

    $('.action-toggle-donate').off('click').on('click', function() {
      self.toggleInfoOverlay('showDonate', '', '', null);
    });

    $('.action-toggle-home').off('click').on('click', function(event) {
      event.stopPropagation();
      //self.toggleMenu('hide');
      self.toggleHomeOverlay('show');
    });

    $('.action-toggle-video').off('click').on('click', function(event) {
      event.stopPropagation();
      self.overlayTrigger('video');
    });

    $('.broadcast-overlay-close').click(function(event) {
      event.stopPropagation()
      self.toggleMenu('show')
      self.toggleBroadcastOverlay('hide', {})
    });

    $('.fullscreen-overlay-close').click(function(event) {
      event.stopPropagation()
      self.toggleFullScreenOverlay('hide', {})
    });

    $('.watch-live-broadcast').off('click').on('click', function(event) {
      event.stopPropagation()
      self.loadLiveStatic()
      //self.loadLiveBroadcast()
    });

    $('.action-refresh-page').off('click').on('click', function(event) {
      event.stopPropagation()
      window.location.reload()
    });

    $('.action-play-live').off('click').on('click', function() {
      Player.overlay.last = 'video'
      Player.toggleLiveOverlay('hide')
      if (Player.mobile) {
        Player.loadLiveStatic()
      } else {
        Player.api.play()
      }
    });

    $('.action-close-menu').off('click').on('click', function() {
      self.toggleMenu('hide')
    });

    $('.action-subscribe-to-broadcast').off('click').on('click', function() {
      self.toggleMenu('hide')
      self.toggleSignupOverlay('show')
    });

    $('.action-menu-archive-list').off('click').on('click', function() {
      self.toggleMenuArchiveView('show')
    });

    $('.action-menu-live-chat').off('click').on('click', function() {
      self.toggleMenuLiveChat('show')
    });

    $('#menu-donate').click(function() {
      self.toggleMenuDonateView('show')
    });

    $('.action-lock-back-to-home').click(function(e) {
      e.stopPropagation()
      self.actionBackToHome()
    });

    $('.back-to-home').click(function() {
      self.toggleMenuHome('show')
    });

    $('.action-menu-about').click(function() {
      self.toggleMenuAboutView('show')
    });
    $('.action-play').off('click').on('click', function() {
      self.api.play()
    });
    $('.context-menu-close').off('click').on('click', function() {
      self.toggleContextMenu()
    });
  },
  broadcastQuery(){
    var broadcastQuery = $('#video-list-filter').val()
    if( broadcastQuery.length ){
     //debug('BD query: %s: ', broadcastQuery)
      this.appendArchiveList(broadcastQuery)
    }
  },
  broadcastQueryReset(){
   //debug('BD broadcastQueryReset function called')
    $('#video-list-filter').val('')
    $('#filter-reset-btn').hide()
    this.appendArchiveList()
  },
  actionBackToHome(){
    $('.player-lock').hide()
    if (this.mobile) {
      this.api.unload()
    }
    this.toggleHomeOverlay('show')
  },
  toggleSignupOverlay: function(display) {
    if (display === 'hide') {
      this.hideOverlay()
    } else if (display == 'show') {
      var self = this
      this.overlayUpdate('signup')
      $('#player-overlay').removeClass().addClass('signup-overlay')
      var template = require('./templates/signup.ejs')
      var html = template()
      $('.signup-overlay').html(html)
      this.emailSignUp()
      $('.signup-overlay-close').click(function(event) {
        event.stopPropagation()
        if (!self.qs.liveOnly) self.toggleMenu('show')
        self.toggleSignupOverlay('hide')
      })
    }
  },
  toggleArchivesOverlay: function(display) {
   //debug('BD toggleArchivesOverlay function called with action %j',display)
    if (display === 'hide') {
      //show the toolbox
      //$('.fp-ss-toolbox').show()
      this.hideOverlay()
    } else if (display == 'show') {
      this.overlayUpdate('archives')
      $('#player-overlay').removeClass().addClass('archives-overlay')
      $('.archive-list-section').show()
      $('#player-overlay').show()
      if( !$("#video-list").length ){
       //debug('BD genrating archive owl carousel')
        var self = this
        var template = require('./templates/archives.ejs')
        var html = template()
        $('.archives-overlay').html(html)
        if (this.qs.showArchives ){
           this.appendArchiveList()
        }
        $('.archive-list-section').show()
        $('.archives-overlay-close').click(function(event) {
          event.stopPropagation()
          self.toggleArchivesOverlay('hide')
        })
      } else {
       //debug('BD archive html should have already been generated')
      }
      if($('.fp-ss-toolbox').length){
        $('.fp-ss-toolbox').hide();
      }
    }
  },
  toggleScheduleOverlay: function(display) {
   //debug('BD toggleScheduleOverlay function called with action %j',display)
    if (display === 'hide') {
      //show the toolbox
      //$('.fp-ss-toolbox').show()
      this.hideOverlay()
    } else if (display == 'show') {
      this.overlayUpdate('schedule')
      $('#player-overlay').removeClass().addClass('schedule-overlay')
      $('#player-overlay').show()
      if( !$(".broadcast-list li").length ){
        var self = this
        var template = require('./templates/schedule.ejs')
        var html = template()
        $('.schedule-overlay').html(html)
        this.appendUpcomingBroadcasts()
        $('.schedule-overlay-close').click(function(event) {
          event.stopPropagation()
          self.toggleScheduleOverlay('hide')
        })
        if( this.qs.showSubscribe ){
          $('#subscribe-btn').show()
          //append the URL
          $("#subscribe-btn").attr("href", "https://streamspot.com/subscribe-to-schedule?id=" + this.broadcaster.idHash)
        }
      } else {
       //debug('BD schedule html should have already been generated')
      }
      //hide the toolbox
      //$('.fp-ss-toolbox').hide()
    }
  },
  toggleAudioOnly: function(){
   debug('BD toggleAudioOnly for live brodcasts function called')
    var setAudioOnly = false
    if( !this.audioOnly ){
      setAudioOnly = true
    }
    //resets the qselector
    this.currentResolution = {resolution: 'auto'};
      if (setAudioOnly) {
       //debug('BD starting audio-only broadcast')
      $(this.flowplayerId).addClass('is-audio-only')
      if( this.broadcaster.isMBR ){
        $(".fp-qsel").hide()
      }
    } else {
     //debug('BD ending audio-only broadcast')
      $(this.flowplayerId).removeClass('is-audio-only')
      if( this.broadcaster.isMBR ){
        $(".fp-qsel").show()
      }
    }

    var video = {
      custom_name: this.broadcaster.name + ' Live Broadcast',
      //src: this.broadcaster.live_src, //replace with currentLive
      src: this.liveManifest,
      enableDVR: this.enableDVR,
      live: true,
      audioOnly: setAudioOnly
    }

    //this loads the clip
    var clip = this.getBasePlayerClip(video)

    this.api.conf.clip = clip
    this.api.load(clip)
    //use video for listners
    this.emitter.emit('play',video)
  },
  toggleAudioOnlyVOD: function(){
   debug('BD toggleAudioOnly for VOD function called, setAudioOnly %s',this.audioOnly)
    var setAudioOnly = false
    if( !this.audioOnly ){
      setAudioOnly = true
    }
    //resets the qselector
    this.currentResolution = {resolution: 'auto'};
      if (setAudioOnly) {
       //debug('BD starting audio-only broadcast')
      $(this.flowplayerId).addClass('is-audio-only')
      if( this.broadcaster.isMBR ){
        $(".fp-qsel").hide()
      }
    } else {
     //debug('BD ending audio-only broadcast')
      $(this.flowplayerId).removeClass('is-audio-only')
      if( this.broadcaster.isMBR ){
        $(".fp-qsel").show()
      }
    }

    if( this.currentVideo.src.audio_only_hls.length === 0 ){
      debug('BD unable to toggle audio only, audio_only_hls is empty')
      return;
    }
    //append so it works downstream
    this.currentVideo.audioOnly = setAudioOnly

    //debug('BD calling getBasePlayerClip with currentVideo for source ')
    var clip = this.getBasePlayerClip(this.currentVideo)

    this.api.conf.clip = clip
    this.api.load(clip)
    //this.emitter.emit('play') //this threw errors in react, not sure why
  },
  overlayTrigger: function(newContext) {
   //debug('BD overlayTrigger function called with context %s',newContext)
    switch (newContext) {
    case 'home':
      this.toggleHomeOverlay('show')
      break
    case 'video':
     //debug('BD this.overlay.now: %s',this.overlay.now)
      if (this.overlay.now == 'broadcast') {
        this.overlayUpdate('video')
      }
      $('#player-overlay').hide()
      $('#play-overlay').hide()
      this.registerActions()
      this.audioOnly ? {} : this.toggleBackgroundOverlay('hide')
      break
    case 'signup':
      this.toggleSignupOverlay('show')
      break
    case 'info':
      this.toggleInfoOverlay('show', null, '', null)
      break
    case 'live':
      this.toggleLiveOverlay('show')
      break
    default:
      this.toggleHomeOverlay('show')
    }
  },
  toggleLiveOverlay: function(display) {
    if (display === 'hide') {
      this.hideOverlay()
    }
  },
  hideOverlay: function() {
    //debug('BD hide overlay triggered, isbroadcasting: ' + this.broadcaster.isBroadcasting)
    if( this.broadcaster.isBroadcasting && !this.qs.category ){
      //return to live video
      this.overlayTrigger('video')
    } else {
      //return to last state
      //debug('BD returning to overlay: ' + this.overlay.last)
      this.overlayTrigger(this.overlay.last)
    }

    //if player is not loaded, do not show toolbox
    if($('.fp-ss-toolbox').length){
      if( !$(".flowplayer.is-ready").length ){
        $('.fp-ss-toolbox').hide()
      } else {
        $('.fp-ss-toolbox').show();
      }
    }
  },
  getVideoTitle: function(video) {
    return video.custom_name || video.date + ' ' + video.time
  },
  getBasePlayerClip: function(video) {
   debug('BD getBasePlayerClip function called with video %j ', video)
    var conf = {
      title: video.custom_name || video.date + ' ' + video.time,
      subtitles: [],
      sources: []
    }
    if( video.captionFile ){
      var captionPath = cloudfrontAssets + video.captionFile
      debug('captions defined as: %s', captionPath )
      var captions = {
        "default": true,
        kind: "subtitles",
        label: "Subtitles",
        src:  captionPath
      }
      conf.subtitles.push(captions)
    }

    if( video.live ){
      var hlsSource = {
        type: 'application/x-mpegurl',
        //src: video.src.cdn_hls, // HLS, Flash, RTSP //replace with currentLive
        src: video.src,
        live: video.live || false
      }

      if( video.audioOnly ){
        debug('BD audioOnly triggered with source %s: ',this.broadcaster.audio.cdn_src)
        hlsSource.src = this.broadcaster.audio.cdn_src
        this.audioOnly = true
      } else {
        this.audioOnly = false
      }
    } else {

      if( video.gen3 ){
      //video is NOT live
        debug('BD: gen3, using HLS for VOD');
        var hlsSource = {
          type: 'application/x-mpegurl', //moved to MP4
          src: video.src.cdn_hls, //moved to MP4
          live: video.live || false
        }
      } else {
        var hlsSource = {
          //force html5 engine
          //type: 'application/x-mpegurl', //moved to MP4
          //src: video.src.cdn_hls, //moved to MP4
          type: 'video/mp4',
          src: video.src.mp4, // HLS, Flash, RTSP
          live: video.live || false
        }
      }
      //denotes gen3
      if( video.audioOnly ){
        debug('BD VOD audioOnly triggered with source %s: ',video.src.audio_only_hls)
        hlsSource.src = video.src.audio_only_hls
        this.audioOnly = true
      } else {
        this.audioOnly = false
      }
    }

   debug('BD video source: %s', hlsSource.src)

    //intentionally causing an error:
    //hlsSource.src = 'https://streamspot.com/playlist.m3u8'

    //this adds to the clip
    conf.sources.push(hlsSource)
    //if VOD, add HLS fallback
    if( !video.live && video.src.cdn_hls != "" && video.src.cdn_hls != null && !video.gen3 ){
      var mp4Source = {
        type: 'application/x-mpegurl',
        src: video.src.cdn_hls, // HLS, Flash, RTSP
        live: video.live || false
      }
      //this adds the clip
      conf.sources.push(mp4Source)
     debug('BD HLS Backup source: %s', mp4Source.src)
    }

    //see if we should add DVR
    if( video.live && this.enableDVR ){
      debug('adding dvr to live configuration')
      conf.dvr = true
    }

    return conf
  }
}

window.Player = Player
module.exports = Player



// WEBPACK FOOTER //
// ./src/player.js